import { render, staticRenderFns } from "./zouduAccessRecords.vue?vue&type=template&id=1dfc1216&scoped=true"
import script from "./zouduAccessRecords.vue?vue&type=script&lang=js"
export * from "./zouduAccessRecords.vue?vue&type=script&lang=js"
import style0 from "./zouduAccessRecords.vue?vue&type=style&index=0&id=1dfc1216&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc1216",
  null
  
)

export default component.exports